var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gundong",attrs:{"id":"app"}},[(_vm.isHide)?_c('Tops',{attrs:{"isTops":_vm.isTops}}):_vm._e(),_c('router-view'),(_vm.isHide)?_c('Foots'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }